import script from "./MapVector.vue?vue&type=script&setup=true&lang=js"
export * from "./MapVector.vue?vue&type=script&setup=true&lang=js"

import "./MapVector.vue?vue&type=style&index=0&id=83fcf2c0&lang=scss&scoped=true"
import "./MapVector.vue?vue&type=style&index=1&id=83fcf2c0&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83fcf2c0"]])

export default __exports__